// extracted by mini-css-extract-plugin
module.exports = {"title":"QuizTitle_title__3r840","container":"QuizTitle_container__Fissk"};